/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminTransactionsGetAdminTransactionsParams,
  PagedResultOfTransactionSummaryDto,
  TransactionDetailDto,
  TransactionPayloadDto,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const adminTransactionsGetAdminTransactions = (
  params?: AdminTransactionsGetAdminTransactionsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfTransactionSummaryDto>(
    { url: `/admin/transactions`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminTransactionsGetAdminTransactionsQueryKey = (
  params?: AdminTransactionsGetAdminTransactionsParams,
) => {
  return [`/admin/transactions`, ...(params ? [params] : [])] as const;
};

export const getAdminTransactionsGetAdminTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
  TError = unknown,
>(
  params?: AdminTransactionsGetAdminTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminTransactionsGetAdminTransactionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>
  > = ({ signal }) => adminTransactionsGetAdminTransactions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsGetAdminTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>
>;
export type AdminTransactionsGetAdminTransactionsQueryError = unknown;

export function useAdminTransactionsGetAdminTransactions<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
  TError = unknown,
>(
  params: undefined | AdminTransactionsGetAdminTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactions<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
  TError = unknown,
>(
  params?: AdminTransactionsGetAdminTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactions<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
  TError = unknown,
>(
  params?: AdminTransactionsGetAdminTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminTransactionsGetAdminTransactions<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
  TError = unknown,
>(
  params?: AdminTransactionsGetAdminTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminTransactionsGetAdminTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminTransactionsGetAdminTransactionsIdGuid = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<TransactionDetailDto>(
    { url: `/admin/transactions/${id}`, method: 'GET', signal },
    options,
  );
};

export const getAdminTransactionsGetAdminTransactionsIdGuidQueryKey = (id?: string) => {
  return [`/admin/transactions/${id}`] as const;
};

export const getAdminTransactionsGetAdminTransactionsIdGuidQueryOptions = <
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminTransactionsGetAdminTransactionsIdGuidQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>
  > = ({ signal }) => adminTransactionsGetAdminTransactionsIdGuid(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsGetAdminTransactionsIdGuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>
>;
export type AdminTransactionsGetAdminTransactionsIdGuidQueryError = unknown;

export function useAdminTransactionsGetAdminTransactionsIdGuid<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactionsIdGuid<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactionsIdGuid<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminTransactionsGetAdminTransactionsIdGuid<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminTransactionsGetAdminTransactionsIdGuidQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Decrypted, PCI-masked request/enriched/response bodies for a single transaction. Bodies are returned as strings; non-JSON content passes through unchanged. Each body is null when capture was disabled at the time of the call, the retention reaper has trimmed it, or that leg of the call did not occur (e.g. no enriched body when the request was rejected before reaching Adyen).
 */
export const adminTransactionsGetAdminTransactionsIdGuidPayload = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<TransactionPayloadDto>(
    { url: `/admin/transactions/${id}/payload`, method: 'GET', signal },
    options,
  );
};

export const getAdminTransactionsGetAdminTransactionsIdGuidPayloadQueryKey = (id?: string) => {
  return [`/admin/transactions/${id}/payload`] as const;
};

export const getAdminTransactionsGetAdminTransactionsIdGuidPayloadQueryOptions = <
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminTransactionsGetAdminTransactionsIdGuidPayloadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>
  > = ({ signal }) =>
    adminTransactionsGetAdminTransactionsIdGuidPayload(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsGetAdminTransactionsIdGuidPayloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>
>;
export type AdminTransactionsGetAdminTransactionsIdGuidPayloadQueryError = unknown;

export function useAdminTransactionsGetAdminTransactionsIdGuidPayload<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactionsIdGuidPayload<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactionsIdGuidPayload<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminTransactionsGetAdminTransactionsIdGuidPayload<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsIdGuidPayload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminTransactionsGetAdminTransactionsIdGuidPayloadQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminTransactionsGetAdminTransactionsExport = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<void>({ url: `/admin/transactions/export`, method: 'GET', signal }, options);
};

export const getAdminTransactionsGetAdminTransactionsExportQueryKey = () => {
  return [`/admin/transactions/export`] as const;
};

export const getAdminTransactionsGetAdminTransactionsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminTransactionsGetAdminTransactionsExportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>
  > = ({ signal }) => adminTransactionsGetAdminTransactionsExport(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsGetAdminTransactionsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>
>;
export type AdminTransactionsGetAdminTransactionsExportQueryError = unknown;

export function useAdminTransactionsGetAdminTransactionsExport<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactionsExport<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
          TError,
          Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetAdminTransactionsExport<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminTransactionsGetAdminTransactionsExport<
  TData = Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminTransactionsGetAdminTransactionsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminTransactionsGetAdminTransactionsExportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
